import React from 'react';

const VideoIcon = () => {
    return (React.createElement("svg", { width: "51", height: "50", viewBox: "0 0 51 50", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
        React.createElement("path", { d: "M5.33398 13.75C5.33398 10.2982 8.13221 7.5 11.584 7.5H31.584C35.0358 7.5 37.834 10.2982 37.834 13.75V36.25C37.834 39.7018 35.0358 42.5 31.584 42.5H11.584C8.13221 42.5 5.33398 39.7018 5.33398 36.25V13.75Z", fill: "#1CB4FF" }),
        React.createElement("path", { d: "M35.334 21.8641C35.334 21.1343 35.6529 20.4409 36.207 19.966L43.707 13.5374C45.3287 12.1474 47.834 13.2997 47.834 15.4356V34.5644C47.834 36.7003 45.3287 37.8526 43.707 36.4626L36.207 30.034C35.6529 29.5591 35.334 28.8657 35.334 28.1359V21.8641Z", fill: "#1CB4FF" })));
};

export { VideoIcon as default };
//# sourceMappingURL=videoIcon.js.map
